import http from "./httpService";
//const apiUrl = process.env.REACT_APP_API_URL;
//const apiUrl = "http://localhost:61682//api";
const apiUrl = http.getApiURL();

export function preLoadFormDetails(menuItemCode, reportId) {
  const config = {
    headers: {
      MenuItemCode: menuItemCode,
      ReportId: reportId,
    },
  };
  return http.get(`${apiUrl}/General/PreLoadFormDetails`, config);
}

export function getFromReportLinks(formID) {
  const config = {
    headers: {
      FormId: formID,
    },
  };
  return http.get(`${apiUrl}/General/GetFromReportLinks`, config);
}

export function getReportControls(reportId) {
  return http.get(`${apiUrl}/Reports/GetReportControls?ReportId=` + reportId);
}

export function getReport(reportId, criteria) {
  const config = {
    headers: {
      ReportId: reportId,
    },
  };
  const body = {
    ReportId: reportId,
    Parameters: criteria,
  };
  return http.post(
    `${apiUrl}/Reports/GetReportPath`,
    { dataObj: JSON.stringify(body) },
    config
  );
}

export function GetCompanies() {
  return http.get(`${apiUrl}/General/GetCompanies`);
}

export function GetUserMenu() {
  return http.get(`${apiUrl}/General/GetUserMenu`);
}

export function GetUserProfile() {
  return http.get(`${apiUrl}/General/GetUserProfile`);
}

export function GetUserReportsMenu() {
  return http.get(`${apiUrl}/Reports/GetUserReports`);
}

export function search(lookupId, formID, reportID, anotherCriteria) {
  const config = {
    headers: {
      FormId: formID,
      ReportID: reportID,
    },
  };
  let url = `${apiUrl}/General/Search?LookupId=${lookupId}`;
  url += anotherCriteria ? `&AnotherCriteria=${anotherCriteria}` : "";

  return http.get(url, config);
}

export function getNextCode(menuItemCode, fieldName, criteria) {
  const config = {
    headers: {
      MenuItemCode: menuItemCode,
    },
  };
  let url = `${apiUrl}/General/GetNextCode?FieldName=${fieldName}`;
  url += criteria ? `&Criteria=${criteria}` : "";

  return http.get(url, config);
}

export function getDashBoardChartData() {
  return http.get(`${apiUrl}/Dashboard/revenue`);
}

// Chart Data Services
export function getLineChartData(endpoint) {
    return http.get(`${apiUrl}/Dashboard/revenue`);

}

export function getDoughnutChartData(endpoint) {
    return http.get(`${apiUrl}/Dashboard/doughnut`);
  // return http.get(`${apiUrl}${endpoint}`);
}

export function getBarChartData(endpoint) {
  return http.get(`${apiUrl}/Dashboard/bar`);
}

export function getStatsData(endpoint) {
  return http.get(`${apiUrl}/Dashboard/${endpoint}`);
}
